export default __webpack_public_path__ + "static/media/q9_step5.d713f212.png";